import React from "react";
import "../style/HeroImageWithText.css";
import heroImage from "../assets/background.png";

const HeroImageWithText = () => {
  return (
    <div className="hero-container">
      <img
        src={heroImage}
        alt="Cybersecurity Hero"
        className="hero-image"
      />
    </div>
  );
};

export default HeroImageWithText;
